import { render, staticRenderFns } from "./NavAuthButton.vue?vue&type=template&id=1b07d4f0"
import script from "./NavAuthButton.vue?vue&type=script&lang=js"
export * from "./NavAuthButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports